import { CloseWebviewEvent } from '../../sdk/close.webview.event';
import ErrorRoundImage from '../../assets/images/error-round.webp';
import { CompleteQueryParams } from './CompletePage';
import WalletIcon from '../../components/shared/Icons/WalletIcon';
import NavigationUtils from '../../utils/navigation.utils';

export const CompletePageFailureType = {
  CREDIT_ONBOARDING_FAILURE: 'credit-onboarding-failure',
  CREDIT_MICROLOAN_FAILURE: 'credit-microloan-failure',
  CREDIT_REPAY_FAILURE: 'credit-repay-failure',
  POS_FAILURE: 'pos-failure',
  SEND_MONEY_TO_COMPANY_FAILURE: 'send-money-to-company-failure',
};

export const FailureConfig = (dictionary, t, getOrganization) => {
  return {
    [CompletePageFailureType.CREDIT_ONBOARDING_FAILURE]: {
      image: ErrorRoundImage,
      title: t('Hmm...'),
      text: t(
        "It looks like we can't approve your credit application right now.",
      ),
      subtitle: t('You can still use your {company_name} like cash', {
        '{company_name}': getOrganization(
          dictionary[CompleteQueryParams.ORGANIZATION_CODE],
        ),
      }),
      ctaText: t('Go back to home'),
      ctaAction: () => {
        CloseWebviewEvent.closedByUser();
      },
      onCloseClick: () => {
        CloseWebviewEvent.closedByUser();
      },
    },
    [CompletePageFailureType.CREDIT_MICROLOAN_FAILURE]: {
      image: ErrorRoundImage,
      title: t('Ooops!'),
      text: t('Something went wrong'),
      ctaText: t('Try Again'),
      ctaAction: () => {
        NavigationUtils.back();
      },
      onCloseClick: () => {
        CloseWebviewEvent.closedByUser();
      },
    },
    [CompletePageFailureType.CREDIT_REPAY_FAILURE]: {
      image: ErrorRoundImage,
      title: t('Ooops!'),
      text: t('Something went wrong with your payment'),
      subtitle: t("Don't worry, we didn't debit any amount for your balance"),
      ctaText: t('Retry'),
      icon: <WalletIcon />,
      ctaAction: () => {
        NavigationUtils.back();
      },
      onCloseClick: () => {
        CloseWebviewEvent.closedByUser();
      },
    },
    [CompletePageFailureType.POS_FAILURE]: {
      image: ErrorRoundImage,
      title: t('Ooops!'),
      text: t('Something went wrong'),
      ctaText: t('Try Again'),
      ctaAction: () => {
        NavigationUtils.back();
      },
      onCloseClick: () => {
        CloseWebviewEvent.closedByUser();
      },
    },
    [CompletePageFailureType.SEND_MONEY_TO_COMPANY_FAILURE]: {
      image: ErrorRoundImage,
      title: t('Ooops!'),
      text: t('Something went wrong'),
      ctaText: t('Try Again'),
      ctaAction: () => {
        NavigationUtils.back();
      },
      onCloseClick: () => {
        CloseWebviewEvent.closedByUser();
      },
    },
  };
};
